
import {Component, Vue} from 'vue-property-decorator'
import {backToBefore} from "@/utils/h5ToApp";

@Component
export default class About extends Vue {
    handleBack() {
        backToBefore()
    }
}
